import { render, staticRenderFns } from "./mainInfo.vue?vue&type=template&id=88a3da82&scoped=true&"
import script from "./mainInfo.vue?vue&type=script&lang=js&"
export * from "./mainInfo.vue?vue&type=script&lang=js&"
import style0 from "./mainInfo.vue?vue&type=style&index=0&id=88a3da82&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88a3da82",
  null
  
)

export default component.exports